module.exports = __webpack_public_path__ + "static/media/julesMap.84c207d8.png";